import React from 'react';
import { PendingDispenseQLD } from '../components/PendingDispenseQLD';

export default function () {
    return <PendingDispenseQLD />;
}
